/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React, { useCallback } from 'react';
import { LobbyStatus } from './LobbiesList';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Button } from '../common';

export interface ILobbiesHeaderProps {
  setStatus: (event: React.MouseEvent<HTMLElement>, status: LobbyStatus) => void;
  lobbiesStatus: LobbyStatus;
  handleRefetch: (callback?: () => void) => void;
}

export const LobbiesListHeader = (props: ILobbiesHeaderProps) => {
  const [refreshDisabled, setRefreshDisabled] = React.useState(false);
  const onClickRefetch = useCallback(() => {
    setRefreshDisabled(true);
    props.handleRefetch();
    setTimeout(() => {
      setRefreshDisabled(false);
    }, 3000);
  }, []);

  return (
    <div
      css={css`
        width: 80%;
        padding: 0 10%;
        box-sizing: initial;
        border-bottom: 2px solid #7530e3;
        & div[role='group'] {
          justify-content: space-between;
          display: flex;
          flex-wrap: wrap;
          padding: 10px 0;
        }
        & .btn {
          font-family: Pixelated, Arial, Helvetica, sans-serif !important;
          font-size: 20px !important;
          background-color: rgb(117 48 227) !important;
          color: #fff !important;
          height: 40px;
          border-radius: 0 !important;
          border-color: #7530e3 !important;
          &[aria-pressed='true'] {
            background-color: #4d1f96 !important;
            border-color: #4d1f96 !important;
          }
          &:active,
          &:focus,
          &:hover {
            background-color: #4d1f96;
            border-color: #4d1f96;
            box-shadow: 0 0 0 0.25rem rgb(37 15 73 / 50%);
          }
          @media (min-width: 992px) {
            width: 32.5%;
            margin: 4px 0;
            &:not(:first-of-type) {
              margin-left: 0 !important;
            }
          }
          @media (max-width: 991px) {
            width: 49%;
            margin: 4px 0;
            &:not(:first-of-type) {
              margin-left: 0 !important;
            }
          }
        }
        & .refresh-bttn-container {
          text-align: right;
          margin-bottom: 12px;

          @-moz-keyframes spin {
            100% {
              -moz-transform: rotate(180deg);
            }
          }
          @-webkit-keyframes spin {
            100% {
              -webkit-transform: rotate(180deg);
            }
          }
          @keyframes spin {
            100% {
              -webkit-transform: rotate(180deg);
              transform: rotate(180deg);
            }
          }
          & .refresh-bttn {
            padding: 0 14px 0 0 !important;
            box-sizing: border-box;
            position: relative;

            &:after {
              content: '';
              background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDQ5Mi45IDQ5Mi45IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0OTIuOSA0OTIuOTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPgo8Zz4KCTxnPgoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMjIuOSwzNzQuMmMtMjAuMS0xOC4xLTM0LjYtMzkuOC00NC4xLTYzLjFjLTI1LjItNjEuOC0xMy40LTEzNS4zLDM1LjgtMTg2bDQ1LjQsNDUuNGMyLjUsMi41LDcsMC43LDcuNi0zCgkJCUwxOTIuNCw1LjJjMC40LTIuNy0xLjktNS00LjYtNC42TDI1LjQsMjUuNGMtMy43LDAuNi01LjUsNS4xLTMsNy42bDQ1LjUsNDUuNWMtNzUuMSw3Ni44LTg3LjksMTkyLTM4LjYsMjgyCgkJCWMxNC44LDI3LjEsMzUuMyw1MS45LDYxLjQsNzIuN2M0NC40LDM1LjMsOTksNTIuMiwxNTMuMiw1MS4xbDEwLjItNjYuN0MyMDcuNCw0MjEuNiwxNTkuNCw0MDcuMiwxMjIuOSwzNzQuMnoiLz4KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDI0LjksNDE0LjNjNzUuMS03Ni44LDg3LjktMTkyLDM4LjYtMjgyYy0xNC44LTI3LjEtMzUuMy01MS45LTYxLjQtNzIuN2MtNDQuNC0zNS4zLTk5LTUyLjItMTUzLjItNTEuMQoJCQlsLTEwLjIsNjYuN2M0Ni42LTQsOTQuNywxMC40LDEzMS4yLDQzLjRjMjAuMSwxOC4xLDM0LjYsMzkuOCw0NC4xLDYzLjFjMjUuMiw2MS44LDEzLjQsMTM1LjMtMzUuOCwxODZsLTQ1LjQtNDUuNAoJCQljLTIuNS0yLjUtNy0wLjctNy42LDNsLTI0LjgsMTYyLjNjLTAuNCwyLjcsMS45LDUsNC42LDQuNmwxNjIuNC0yNC44YzMuNy0wLjYsNS40LTUuMSwzLTcuNkw0MjQuOSw0MTQuM3oiLz4KCTwvZz4KPC9nPgo8L3N2Zz4K');
              width: 18px;
              height: 18px;
              background-repeat: no-repeat;
              background-size: cover;
              position: absolute;
              top: 10px;
              left: calc(50% + 68px);
            }
            &.disabled {
              background: #a677f1 !important;
              border-color: #a677f1 !important;
            }
            &:hover {
              &:after {
                -webkit-animation: spin 0.4s ease-out forwards;
                -moz-animation: spin 0.4s ease-out forwards;
                animation: spin 0.4s ease-out forwards;
              }
            }
          }
        }
      `}
    >
      <ToggleButtonGroup value={props.lobbiesStatus} exclusive onChange={props.setStatus} aria-label="Lobby Status">
        <ToggleButton className="btn btn-primary btn-lg px-5 gap-3" value="checking" aria-label="checking">
          Pending
        </ToggleButton>
        <ToggleButton className="btn btn-primary btn-lg px-5 gap-3" value="created" aria-label="Created">
          Created
        </ToggleButton>
        <ToggleButton className="btn btn-primary btn-lg px-5 gap-3" value="started" aria-label="Started">
          Started
        </ToggleButton>
        <ToggleButton className="btn btn-primary btn-lg px-5 gap-3" value="ended" aria-label="Ended">
          Ended
        </ToggleButton>
        <ToggleButton className="btn btn-primary btn-lg px-5 gap-3" value="refunded" aria-label="Refunded">
          Refunded
        </ToggleButton>
        <ToggleButton className="btn btn-primary btn-lg px-5 gap-3" value="failed" aria-label="Failed">
          Failed
        </ToggleButton>
      </ToggleButtonGroup>

      <div className={'refresh-bttn-container'}>
        <Button
          label={'Refresh Lobbies'}
          className={'refresh-bttn'}
          dataSize={'small'}
          onClick={!refreshDisabled ? onClickRefetch : () => null}
          disabled={refreshDisabled}
        />
      </div>
    </div>
  );
};
